import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { BaseGuard } from './baseGuard';

import { FormDefinitionService } from '../services';
import { LoginService } from '../services';

import { Observable } from 'rxjs';
import * as _ from 'lodash';

@Injectable()
export class CanActivateForFormsGuard extends BaseGuard implements CanActivate {

    constructor(
        private formService: FormDefinitionService,
        loginService: LoginService,
        router: Router) {
        super(router, loginService);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        let self = this;

        return new Observable<boolean>(observer => {
            self.formService.getFormDefinitionAllActive().subscribe((t) => {
                if (!t || !t.length) {
                    observer.next(false);
                    self.navigateToLogin(route);
                } else {
                    observer.next(true);
                }
                observer.complete();
            },
                err => {
                    observer.error(err);
                    self.navigateToLogin(route);
                });
        });
    }
}